module.exports = __webpack_public_path__ + "static/DHCM2-ec4816c7ecf4c95e24bdff99a01b698a.jpg";